<label>
  <small class="loaderFile">
    <img src="/assets/images/preloader.gif" style="height: 18px;width: auto; display: inline-block; margin-bottom: -3px;" />
    Please Wait...
    <span class="close-icon" style="cursor: pointer; margin-left: 5px;" (click)="stopLoader()">&#10006;</span>
  </small>
</label>
